import { format } from "fecha"
import TimeAgo from "javascript-time-ago"

const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate()

export default {
  methods: {
    convertDateToLocale(dateStr, mask) {
      const date = new Date(dateStr)
      mask ||= "DD/MM/YYYY"

      return format(date, mask)
    },
    messageDate(dateStr) {
      const date = new Date(dateStr)
      const today = new Date()
      const yesterday = new Date(today)
      yesterday.setDate(today.getDate() - 1)

      if (sameDay(date, today)) return this.$t("messages.today")
      if (sameDay(date, yesterday)) return this.$t("messages.yesterday")

      return format(date, "DD/MM/YYYY")
    },
    messageTimestamp(dateStr) {
      const date = new Date(dateStr)

      if (sameDay(date, new Date())) return format(date, "HH:mm")

      return format(date, "DD/MM/YYYY · HH:mm")
    },
    shortDay(dateStr, lang = "pt-PT") {
      const date = new Date(dateStr)
      const month = date
        .toLocaleDateString(lang, { month: "short" })
        .replace(".", "")

      return `${date.getDate()} ${month.charAt(0).toUpperCase()}${month.slice(1)}`
    },
    // locale
    timeAgo(date, lang = "pt-PT") {
      const timeAgo = new TimeAgo(lang)

      if (date) {
        return timeAgo.format(new Date(date))
      }
    },
    dateLocaleString(date, lang = "pt-PT") {
      const newDate = new Date(date)
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      }

      return newDate.toLocaleDateString(lang, options)
    },
    timeLocaleTimeString(date, lang = "pt-PT") {
      return new Date(date).toLocaleTimeString(lang, {
        hour: "2-digit",
        minute: "2-digit",
      })
    },
  },
}
